import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { Skeleton } from "@/components/feedback/Skeleton";
import { OutboundDetail } from "@/features/warehouse/OutboundDetail";
import { getOutbound, outboundKeys } from "@/features/warehouse/outbound.api";

// BO-Order (docs/design_handoff_wms_mw8/README.md §5): one outbound order, for the office.
export const Route = createFileRoute("/_shell/warehouse/outbound/$id")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "wms_outbound") && !hasModule(context.session, "wms_outbound_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: OrderScreen,
});

function OrderScreen() {
  const { t } = useTranslation();
  const { id } = Route.useParams();
  const { session } = Route.useRouteContext();
  const canEdit = session.roles.includes("admin") || hasModule(session, "wms_outbound_write");
  const query = useQuery({ queryKey: outboundKeys.detail(id), queryFn: () => getOutbound(id), retry: false });

  if (query.isPending) {
    return (
      <div className="wl-page" data-screen-label="Back-office Warehouse Order" aria-busy="true">
        <Skeleton width="280px" height="var(--space-7)" />
        <div style={{ marginTop: "var(--space-4)" }}>
          <Skeleton height="320px" />
        </div>
      </div>
    );
  }
  if (query.isError || !query.data) {
    return (
      <div className="wl-page" data-screen-label="Back-office Warehouse Order">
        <h1 className="t-h2">{t("outbound.notFound")}</h1>
      </div>
    );
  }
  return (
    <div className="wl-page" data-screen-label="Back-office Warehouse Order">
      <OutboundDetail order={query.data} canEdit={canEdit} userId={session.userId} canOpenDossier={hasModule(session, "dossiers")} />
    </div>
  );
}
